import {Component, Input, OnInit} from '@angular/core';
import {ILedInfo} from "../../../../../models/common";

@Component({
  selector: 'edsng-led-info',
  templateUrl: './led-info.component.html',
  styleUrls: ['./led-info.component.css']
})
export class LedInfoComponent implements OnInit {

  @Input() led:ILedInfo;
  constructor() { }

  ngOnInit() {
  }

}
